import { Icon } from 'assets/index'
import { useContext, useState } from 'react'
import { UserContext } from 'context/userContext'
import { Input, Label, Div } from './style'

interface IRadioButtonProps {
  data?: any
  small?: boolean
  width: number
}

export default function RadioButton(props: IRadioButtonProps) {
  const { data, small, width } = props
  const [selected, setSelected] = useState<number>(0)
  const { setRadioBtnValue } = useContext(UserContext)

  const isRadioSelected = (value: number): boolean => selected === value

  const handleSelected = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(Number(e.currentTarget.value))
    setRadioBtnValue(data[Number(e.currentTarget.value)].value)
  }

  return (
    <Div width={width}>
      {data.map((btn: any, index: number) => (
        <div className="radio-btn-container">
          {isRadioSelected(index) ? (
            <div className="radio-button-checked">
              <Input
                {...props}
                name="radio-button"
                type="radio"
                value={index}
                id={btn.value}
                checked={isRadioSelected(index)}
                onChange={handleSelected}
              />
            </div>
          ) : (
            <Input
              {...props}
              name="radio-button"
              type="radio"
              value={index}
              id={btn.value}
              checked={isRadioSelected(index)}
              onChange={handleSelected}
            />
          )}

          {!btn.icon ? (
            ''
          ) : (
            <img
              className="radio-btn-icon"
              src={Icon(btn.icon)}
              alt={`radio-btn-${btn.value}`}
            />
          )}
          <Label small={small} htmlFor={btn.value}>
            {btn.value}
          </Label>
        </div>
      ))}
    </Div>
  )
}
